import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H3Font from "Root/profile/components/common/H3Font";
import styles from "./styles.module.scss";
import RegFont from "Root/profile/components/common/RegFont";
const CheckoutHapinessGuarantee = () => {
    return (_jsx("div", { className: styles.hapiness, children: _jsxs("div", { className: styles.wrapper, children: [_jsx(H3Font, { fontWeight: 350, color: "#fff", children: "Happiness Guarantee" }), _jsx(RegFont, { fontWeight: 350, color: "#fff", children: "Don\u2019t like your blend? We\u2019ll work with you to make it right and send you a new blend for free." })] }) }));
};
export default CheckoutHapinessGuarantee;
